import { render } from "./ModalContactResult.vue?vue&type=template&id=17a5c722"
import script from "./ModalContactResult.vue?vue&type=script&lang=ts"
export * from "./ModalContactResult.vue?vue&type=script&lang=ts"
script.render = render

export default script